import React from 'react';
import { Img } from 'react-image';
import classNames from 'classnames';

import Loading from './loading';

function Image(props) {
  return (
    <Img
      loader={
        <div className={classNames(props.className, 'loading-preload')}>
          <Loading />
        </div>
      }
      alt=""
      {...props}
    />
  );
}

export default React.memo(Image);
